<template>
	<div class="container page" style="background-color: #1f1c1f;">
		<van-nav-bar :title="$t('setting.set_money_pwd')" class="nav-bar">
			<template #left>
				<img src="/img/newLogin/download.png" @click="back()" style="width: 20px;height: 15px;" />
			</template>
		</van-nav-bar>
		<van-cell-group>
			<!-- <div class="c_p_j">{{ $t('setting.old_pwd') }}</div>
      <van-field v-model="old_password"  :placeholder="$t('setting.old_pwd_tip')" type="password" /> -->

			<div class="c_p_j">{{ $t('setting.new_pwd') }}</div>
			<van-field v-model="o_new_password" :placeholder="$t('setting.new_pwd_tip')" type="password" />
			<div class="c_p_j">{{ $t('setting.new_again_tip') }}</div>
			<van-field v-model="t_new_password" :placeholder="$t('setting.new_again_tip')" type="password" />
		</van-cell-group>
		<div class="sub-btn" @click="save()">
			{{ $t('q59') }}
		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				o_new_password: "",
				t_new_password: "",
				old_password: "",
				userInfo: {}
			};
		},
		methods: {
			back() {
				return window.history.back();
			},
			save() {
				if (this.o_new_password === "" || this.o_new_password === null || this.o_new_password === undefined) {
					this.$toast.fail(this.$t("setting.prefect"));
					return false;
				}
				if (this.t_new_password === "" || this.t_new_password === null || this.t_new_password === undefined) {
					this.$toast.fail(this.$t("setting.prefect"));
					return false;
				}
				if (this.old_password === "" || this.old_password === null || this.old_password === undefined) {
					this.$toast.fail(this.$t("setting.prefect"));
					return false;
				}
				if (this.o_new_password !== this.t_new_password) {
					this.$toast(this.$t("setting.pwd_error"));
					return false;
				}
				this.$http({
					method: 'post',
					data: {
						// old_password:this.old_password,
						paypassword: this.o_new_password
					},
					url: 'user_set_paypw'
				}).then(res => {
					if (res.code === 200) {
						this.$toast(res.msg);
						setTimeout(() => {
							localStorage.clear()
							this.$router.push("Login")
						}, 500);

					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				})
			},
			getUserInfo() {
				this.$http({
					method: 'get',
					url: 'user_info'
				}).then(res => {
					if (res.code === 200) {
						this.userInfo = res.data;
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				})
			}
		},
		created() {
			if (!localStorage.getItem('token')) {
				this.$router.push({
					path: '/Login'
				})
			} else {
				this.getUserInfo();
			}
		}
	};
</script>

<style lang='less' scoped>
	@import "../../assets/css/base.css";

	.sub-btn {
		background: linear-gradient(#fde3ca, #e7b486);


		display: inline-block;
		border: none;
		cursor: pointer;
		color: #68302c;
		font-size: 32px;
		-moz-border-radius: 5px;
		-webkit-border-radius: 5px;
		border-radius: 2rem;
		margin: 60px 40px;
		font-weight: bold;
		text-align: center;
		padding: 20px 0;
	}

	.van-cell {
		background: linear-gradient(120deg, #212121, #313131);
		margin: 0 30px;
		box-sizing: border-box;
		width: initial;
		border: 1px solid #766350;
		border-radius: 10px;
		font-size: 28px;
		padding: 20px 26px;

		/deep/ .van-field__control {
			color: #f3c7a2;
		}

		&:after {
			display: none;
		}
	}

	.van-cell-group {
		background-color: transparent;

		&:after {
			display: none;
		}
	}

	.c_p_j {
		padding: 26px 30px;
		color: #f3c7a2;
		font-size: 26px;
	}
</style>